import { useState, useEffect } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { LoaderIcon } from '@admin/shared/components/icons/custom/loader';
import { Theme } from '@admin/shared/themes/default';

// styles for component
const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99999,
      color: theme.palette.primary.main,
      background: theme.palette.background.transparentWhite,
    },
    rotate: {
      height: 48,
      width: 48,
      animation: '$spin 1s ease-in-out infinite',
      willChange: 'transform',
    },

    '@keyframes spin': {
      '0%': {
        transform: 'rotate(0deg)',
      },
      '100%': {
        transform: 'rotate(360deg)',
      },
    },
  }),
  {
    name: 'OMQLoadingIndicator',
  },
);

// Delay in ms, until component should be displayed
const DELAY = 1000;

/**
 * Display circling loading indicator.
 * Used to display that sth is happening in the background,
 * and blocks the view until progress is done.
 *
 * @returns {JSX.Element}
 */
export const LoadingIndicator = (): JSX.Element => {
  const styles = useStyles();
  const [isVisible, setIsVisible] = useState<boolean>(false);

  // delay display of component
  useEffect(() => {
    // set visible after delay
    const timeoutId = setTimeout(() => {
      setIsVisible(true);
    }, DELAY);

    // clear timeout on unmount
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  // if not visible, don't render component
  if (!isVisible) {
    return null;
  }

  return (
    <Box display="flex" alignItems="center" justifyContent="center" className={styles.root}>
      <LoaderIcon className={styles.rotate} />
    </Box>
  );
};
